<template>
  <div
    :class="{'custom-input --horizontal': isHorizontal}"
    class="custom-input"
  >
    <label
      v-if="label"
      :for="list"
    >{{ label }}</label>
    <div>
      <div>
        <input
          ref="input"
          :disabled="disabled"
          :autocomplete="autocomplete"
          :type="inputType"
          :id="list"
          :placeholder="placeholder"
          :class="{inactive: !active, 'custom-input__alert': alert}"
          v-model="inputValue"
          :maxlength="max"
          @blur="handleBlur"
          @focus="handleFocus()"
          @keyup.stop="handleUserInput($event)"
          @keydown="filterKey"
        >
        <slot
          name="icon"
          v-if="!loading"
        >
          <!-- This slot's fallback content is a legacy implementation. Prefer using the slot if you want to add an icon -->
          <!-- legacy implementation start -->
          <i
            v-if="svg && !loading"
            @click="clickOnSvg()"
            :class="{'custom-input__clickable': clickableSvg}"
          >
            <svg>
              <use :xlink:href="inputSvg"></use>
            </svg>
          </i>
          <!-- legacy implementation end -->
        </slot>
        <i
          v-if="loading"
          class="loading"
        >
          <svg
            version="1.1"
            id="loader-1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 50 50"
            style="enable-background: new 0 0 50 50;"
            xml:space="preserve"
          >
            <path
              fill="#000"
              d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
            >
              <animateTransform
                attributeType="xml"
                attributeName="transform"
                type="rotate"
                from="0 25 25"
                to="360 25 25"
                dur="0.6s"
                repeatCount="indefinite"
              ></animateTransform>
            </path>
          </svg>
        </i>
      </div>
      <slot />
    </div>
  </div>
</template>

<script>

export default {
  name: 'CustomInput',
  props: {
    type: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    active: {
      type: Boolean,
      default: false,
    },
    alert: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    svg: {
      type: String,
      default: '',
    },
    clickableSvg: {
      type: Boolean,
      default: false,
    },
    list: {
      type: String,
      default: '',
    },
    isHorizontal: {
      type: Boolean,
      default: false,
    },
    maxValue: {
      type: [Boolean, Number],
      default: false,
    },
    max: {
      type: Number,
      default: null,
    },
    autocomplete: {
      type: String,
      default: 'off',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isNumber: {
      type: Boolean,
      default: false,
    },

  },
  data() {
    return {
      inputValue: '',
      inputType: 'text',
      inputSvg: null,
      itemToEmit: {
        name: null,
        value: null,
      },
    }
  },
  watch: {
    inputValue(val) {
      this.$emit('input', val)
      if (!this.maxValue) {
        return
      }

      if (val > this.maxValue) {
        this.inputValue = String(this.itemToEmit.value)
      }
    },
    value(val) {
      this.inputValue = val
    },
  },
  mounted() {
    this.inputValue = this.value
    this.inputType = this.type
    this.inputSvg = this.svg
  },
  methods: {
    clickOnSvg() {
      this.$emit('click-on-svg', true)
      if (this.type === 'password') {
        this.toggleType()
      }
    },
    toggleType() {
      if (this.inputType === 'text') {
        this.inputType = 'password'
        this.inputSvg = '#icon-eye'
        return
      }
      this.inputType = 'text'

      this.inputSvg = '#icon-eye-cross'
    },

    handleFocus() {
      this.$emit('focus', true)
    },
    handleUserInput(ev) {
      this.itemToEmit.name = this.list
      this.itemToEmit.value = this.inputValue
      this.$emit('key', ev)
      if (this.isNumber) {
        this.inputValue.replace(/\D/, '')
      }
      return this.list
        ? this.$emit('fill-input', this.itemToEmit)
        : this.$emit('fill-input', this.inputValue)
    },

    handleBlur() {
      this.$emit('blur', this.inputValue)
    },

    filterKey(e) {
      if (!this.isNumber) {
        return
      }
      const { key } = e;
      // If is '.' key, stop it
      if (key === '.') return e.preventDefault();
      if (key === '-') return e.preventDefault();
      if (key === ',') return e.preventDefault();
      if (key === '+') return e.preventDefault();

      // OPTIONAL
      // If is 'e' key, stop it
      if (key === 'e') return e.preventDefault();
      if (key === 'E') return e.preventDefault();
    },
  },
}
</script>
<style scoped lang="scss">
@import '../../../../../_src/sass/config/vars';
@import '../../../../../_src/sass/config/mixins';
@import '../../../../../_src/sass/config/responsive';

.custom-input {
  @include shared-svg-inputs;

  align-items: stretch;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: flex-start;
  position: relative;

  &.--horizontal {
    display: flex;
    flex: 1;
    flex-direction: row;
    justify-content: space-between;
    margin: 10px 0;

    label {
      flex: 1;
    }
  }

  &__clickable {
    cursor: pointer;
  }

  &__alert {
    @include alert;
  }

  &.--horizontal {
    flex: 1;

    > div {
      flex: 1;
    }
  }

  > div {
    display: flex;
    flex-direction: column;
    position: relative;
  }
}

.error {
  display: flex;
  flex-direction: column;
  margin-top: 5px;
  text-align: left;
  width: 100%;

  span {
    @include errorInputs;
  }
}

/* } */
label {
  @include labels;

  .custom-input.--horizontal & {
    align-items: center;
    display: flex;
    flex: 1;
    margin-bottom: 0;
    margin-top: 0;
  }
}

.popup-login__signin label {
  margin-bottom: 5px !important;
}

input {
  @include sharable-input;

  width: 100%;

  &::first-letter {
    text-transform: capitalize;
  }

  .-large-text & {
    @include font-size(14px);

    font-family: $f-graphie-bold;
  }

  .-centered & {
    text-align: center;
  }
}

.loading {
  height: 100% !important;
}
</style>
